module.exports = __webpack_public_path__ + "img/Gallery_3_06.aa2a743b.jpeg";